import { render, staticRenderFns } from "./DoctorClinicsView.vue?vue&type=template&id=540ebc2c&scoped=true"
import script from "./DoctorClinicsView.vue?vue&type=script&lang=js"
export * from "./DoctorClinicsView.vue?vue&type=script&lang=js"
import style0 from "./DoctorClinicsView.vue?vue&type=style&index=0&id=540ebc2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ebc2c",
  null
  
)

export default component.exports